import { SpaceDto } from "@braoshzmvavz/picnube-common";
import React from "react";
import { HiSave } from "react-icons/hi";
import SpaceFormModal from "./SpaceFormModal";

export default function SpaceSettingsModal(props: {
  space: SpaceDto;
  onSave: (updatedSpace: SpaceDto) => void;
}) {
  const handleSave = (values: { name: string; description: string }) => {
    props.onSave({
      ...props.space,
      name: values.name,
      description: values.description,
    });
  };

  return (
    <SpaceFormModal
      space={props.space}
      onSave={handleSave}
      submitIcon={HiSave}
      submitLabel="Save Changes"
    />
  );
} 